export default __webpack_public_path__ + "static/technology-hero@2x-21e9ec80ea82f0091dbe8d4a8aedd3f6.png";